// eslint-disable-next-line no-unused-vars
import { StyleSheet } from 'react-native';

const data = {
  figtreeBlack: {
    fontFamily: 'figtree-black',
  },
  figtreeBold: {
    fontFamily: 'figtree-bold',
  },
  figtreeBoldItalic: {
    fontFamily: 'figtree-bold-italic',
  },
  figtreeMedium: {
    fontFamily: 'figtree-medium',
  },
  figtreeMediumItalic: {
    fontFamily: 'figtree-medium-italic',
  },
  figtreeRegular: {
    fontFamily: 'figtree-regular',
  },
};

const styles = StyleSheet.create({
  ...data,
});

export { styles, data };
